import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type UploadIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const UploadIcon = ({
  width = 20,
  height = 20,
  color = tokens.colors.global.white,
  ...props
}: UploadIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20.0083 20.0083"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.86036 13.3389C2.80986 11.9147 1.97776 9.28678 2.8348 6.94192C3.69184 4.59705 6.02242 3.1251 8.50803 3.35882C10.9936 3.59253 13.009 5.47312 13.4139 7.93664C13.5306 7.92834 13.639 7.91997 13.7557 7.91997C15.5827 7.91933 17.1442 9.23526 17.4533 11.0359C17.7623 12.8365 16.7289 14.5978 15.0062 15.2063"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5052 12.5054L10.0042 10.0044L7.50312 12.5054"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0042 10.0044V16.6736"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
